module.exports = __webpack_public_path__ + "f9b99eb8199eccad9491aaa92fc1a838.svg";